import {regionScales} from "../hooks/mapRegionDicts";

export function sumMacroData(data){
  return data.slice(4).reduce((acc, item) => acc + Number(item), 0)
}

export function buildCityKey(city, sortOption){
  const nome = city.slice(0, -5)
  const uf = city.slice(-2)
  return sortOption === 'region' ? `${nome} - ${uf}` : nome
}


export function getScale(jsonState, selectedState) {
  if (jsonState['north_south_distance_km']){
    const distance = jsonState['north_south_distance_km'];
    const config = {
      smallStateThreshold: 100,
      mediumStateThreshold: 400,
      baseScale: 12000,
      mediumScaleFactor: 0.7,
      largeScaleFactor: 0.5,
      minScale: 4000,
      maxScale: 20000
    };
    if(distance > 900 && distance < 1100) return 2800;
    if(distance > 1300) return 2000;
    if(distance > 400 && distance < 500) return 6000
    if(distance === 214.28) return 15000
    if(distance === 1126.8) return 7000;

    if (distance < config.smallStateThreshold) {
      return config.baseScale;
    }

    if (distance < config.mediumStateThreshold) {
      return config.baseScale * config.mediumScaleFactor;
    }

    const scale = config.baseScale * Math.pow(distance/50, -config.largeScaleFactor);
    return Math.max(Math.min(scale, config.maxScale), config.minScale);
  } else {
    return regionScales[selectedState]
  }

}


